import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePickerField } from '../../../models/Field';

@Component({
  selector: 'date-picker-kendo',
  template: `<div [formGroup]="form" class="form-group" [style.display]="isHidden ? 'none' : 'block'">
    <label [attr.for]="fieldKey">{{ field.label }}</label>
    <input
      type="hidden"
      id="{{ field.key + '-hidden' }}"
      [formControlName]="field.key"
    />
    <input
      [attr.disabled]="control.disabled ? true : null"
      class="form-control custom-kendo"
      [ngClass]="
        control.invalid && control.touched ? 'ng-invalid ng-touched' : ''
      "
      [style.width]="field.size ? field.size + 'em' : ''"
      style="max-width: 100%;"
      id="{{ field.key + '-kendo' }}"
    />
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class DatePickerKendoComponent
  implements AfterViewInit, OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() field: DatePickerField;

  formStatusChangeSubscription;

  get isHidden() {
    return this.field.isHidden;
  }

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }

  ngOnInit() {
    this.formStatusChangeSubscription = this.form.statusChanges.subscribe(
      () => {
        const kendoComponent = $(`#${this.field.key}-kendo`).data(
          'kendoDatePicker'
        );
        if (kendoComponent) {
          // Check per-control disabled, not the whole form
          kendoComponent.enable(!this.control.disabled);
        }
      }
    );
  }

  ngAfterViewInit() {
    let pickersAnimation: kendo.ui.DatePickerAnimation = {};
    pickersAnimation.close = {};
    pickersAnimation.close.duration = 300;
    pickersAnimation.close.effects = 'fadeOut zoom:out';
    pickersAnimation.open = {};
    pickersAnimation.open.duration = 300;
    pickersAnimation.open.effects = 'fadeIn zoom:in';

    let pickerOptions: kendo.ui.DatePickerOptions = {};
    pickerOptions.animation = pickersAnimation;
    pickerOptions.format = this.field.dateFormat;
    pickerOptions.start;
    pickerOptions.value = (this.field.value as any) || undefined;
    pickerOptions.parseFormats;
    // pickerOptions.culture = this._localize.getLocale();
    pickerOptions.change = ((evt) => {
      const value = evt.sender.value();
      this.form.controls[`${this.field.key}`].setValue(value);
      this.control.markAsTouched();
      this.control.markAsDirty();
    }).bind(this);

    $(`#${this.field.key}-kendo`).blur(
      (() => {
        this.form.controls[`${this.field.key}`].markAsTouched();
      }).bind(this)
    );
    $(`#${this.field.key}-kendo`)
      .kendoDatePicker(pickerOptions)
      .data('kendoDatePicker');

    // Apply disabled state immediately on first render — without this the picker
    // is always rendered enabled and only reacts after the first statusChanges event.
    const kendoDP = $(`#${this.field.key}-kendo`).data('kendoDatePicker');
    if (kendoDP) {
      kendoDP.enable(!this.control.disabled);
    }

    this.control.valueChanges.subscribe(() => {
      const kendoDatePicker = $(`#${this.field.key}-kendo`).data('kendoDatePicker');
      if (kendoDatePicker) {
        kendoDatePicker.value(this.control.value);
      }
    });
  }

  ngOnDestroy() {
    this.formStatusChangeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/date-picker/date-picker-kendo.component.ts